module.exports = __webpack_public_path__ + "img/tf-cb-y1.9578eee5.gif";